module.exports = __webpack_public_path__ + "static/media/arrow-right-white.2de34181.svg";